import api from '@/utils/api';
import { NotificationManager } from 'react-notifications';
import {
    FETCH_DIRECT_CONSULTATIONS,
    FETCH_DIRECT_CONSULTATION,
    UPDATE_DIRECT_CONSULTATION,
    UPDATE_DIRECT_CONSULTATION_RESULT,
    REMOVE_DIRECT_CONSULTATIONS
} from './types';

export const fetchDirectConsultations = filters => dispatch => {
    return api.get('/direct-consultations', { params: filters }).then(res => {
        dispatch({ type: FETCH_DIRECT_CONSULTATIONS, payload: res.data.data });
        return res.data.data;
    }).catch(err => {
        console.log(err);
        NotificationManager.error(err.response?.data?.msg || 'Không thể tải danh sách tư vấn trực tiếp.');
        throw err;
    });
};

export const fetchDirectConsultation = id => dispatch => {
    return api.get(`/direct-consultations/${id}`).then(res => {
        dispatch({ type: FETCH_DIRECT_CONSULTATION, payload: res.data.data });
        return res.data.data;
    }).catch(err => {
        NotificationManager.error(err.response?.data?.msg || 'Không thể tải chi tiết tư vấn trực tiếp.');
        throw err;
    });
};

export const updateDirectConsultation = (id, data) => dispatch => {
    return api.put(`/direct-consultations/${id}`, data).then(res => {
        dispatch({ type: UPDATE_DIRECT_CONSULTATION, payload: res.data.data });
        NotificationManager.success(res.data.msg || 'Cập nhật nhân viên tư vấn thành công.');
        return res.data.data;
    }).catch(err => {
        NotificationManager.error(err.response?.data?.msg || 'Không thể cập nhật nhân viên tư vấn.');
        throw err;
    });
};

export const updateDirectConsultationResult = (id, data) => dispatch => {
    return api.put(`/direct-consultations/${id}/result`, data).then(res => {
        dispatch({ type: UPDATE_DIRECT_CONSULTATION_RESULT, payload: { id, data } });
        NotificationManager.success(res.data.msg || 'Cập nhật kết quả tư vấn thành công.');
        return res.data.data;
    }).catch(err => {
        NotificationManager.error(err.response?.data?.msg || 'Không thể cập nhật kết quả tư vấn.');
        throw err;
    });
};

export const removeDirectConsultations = ids => dispatch => {
    return api.delete('/direct-consultations', { data: { ids } }).then(res => {
        dispatch({ type: REMOVE_DIRECT_CONSULTATIONS, payload: ids });
        NotificationManager.success(res.data.msg || 'Xóa bản ghi thành công.');
        return res.data;
    }).catch(err => {
        NotificationManager.error(err.response?.data?.msg || 'Không thể xóa bản ghi.');
        throw err;
    });
};
